module.exports = __webpack_public_path__ + "img/print-video-financiamento.f10bc9e8.jpg";